import React, { Component} from 'react';
import styled from "styled-components";
import yellowStar from '../../../assets/imgs/star_yellow.png';
import greyStar from '../../../assets/imgs/greyStar.png';

const FeedbackWrapper = styled.div`

 // background: red;
 // width: 100%;
 // position: relative;
  
  .star-alignment{
    display: flex;
    flex-direction: row;
    margin: 16px 10px;
    justify-content: center;

  }

  .star-div-bubble{
    height:20px;
    width: 20px;
    display: inline-block;
    margin: 0 3px;
    // vertical-align: middle;  
    cursor: pointer;
    img{
        height: 100%;
    }
    &:hover{
     
    }
}
`

class CCRewardsFeedback extends Component {

  constructor(props) {
    super(props);

    this.state = {
        star1:greyStar,
        star2:greyStar,
        star3:greyStar,
        star4:greyStar,
        star5:greyStar,
        
    }

}

handleStarClick(rating){

 
       
  if(rating == 1){
     this.setState({
         star1:yellowStar,
         star2:greyStar,
         star3:greyStar,
         star4:greyStar,
         star5:greyStar,
     })
  }else if(rating == 2){
      this.setState({
          star1:yellowStar,
          star2:yellowStar,
          star3:greyStar,
          star4:greyStar,
          star5:greyStar,
      })
  }else if(rating == 3){
      this.setState({
          star1:yellowStar,
          star2:yellowStar,
          star3:yellowStar,
          star4:greyStar,
          star5:greyStar,
      })
  }else if(rating == 4){
      this.setState({
          star1:yellowStar,
          star2:yellowStar,
          star3:yellowStar,
          star4:yellowStar,
          star5:greyStar,
      })
  }else if(rating == 5){
      this.setState({
          star1:yellowStar,
          star2:yellowStar,
          star3:yellowStar,
          star4:yellowStar,
          star5:yellowStar,
      })
  }

  let inputString =   rating + "<split>" + rating;
  window['autosubmit'](inputString);
//  console.log(rating)

  document.querySelectorAll('.star-div-bubble').forEach(item => {
    item.classList.add('disabled')
  })

}
  
  render() {

    return (
      <FeedbackWrapper>

        <div className="star-alignment" id="starsWrapperID">
            <div className="star-div-bubble" onClick={()=>{this.handleStarClick(1)}}><img src={this.state.star1}></img></div>
            <div className="star-div-bubble" onClick={()=>{this.handleStarClick(2)}}><img src={this.state.star2}></img></div>
            <div className="star-div-bubble" onClick={()=>{this.handleStarClick(3)}}><img src={this.state.star3}></img></div>
            <div className="star-div-bubble" onClick={()=>{this.handleStarClick(4)}}><img src={this.state.star4}></img></div>
            <div className="star-div-bubble" onClick={()=>{this.handleStarClick(5)}}><img src={this.state.star5}></img></div>
                                
        </div>

  
      </FeedbackWrapper> 
  
    )
  }
}





export default CCRewardsFeedback;











